import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { photoFrame, photos } from '../../content/media';

const team = [
  {
    name: '',
    role: '',
    bio: '',
    avatar: 'https://static.readdy.ai/image/1dec6692aa9363a656626d6da331b472/fd1edd626cacac0b8732bbec63505019.png',
  },
  {
    name: '',
    role: '',
    bio: '',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20female%20technology%20CTO%20headshot%2C%20confident%20executive%20woman%20in%20smart%20attire%2C%20clean%20studio%20background%2C%20professional%20lighting%2C%20tech%20executive%20appearance&width=300&height=300&seq=team_2&orientation=squarish',
  },
  {
    name: '',
    role: '',
    bio: '',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20male%20cybersecurity%20executive%20headshot%2C%20confident%20man%20in%20business%20attire%2C%20studio%20portrait%20with%20clean%20neutral%20background%2C%20serious%20professional%20expression&width=300&height=300&seq=team_3&orientation=squarish',
  },
];

const values = [
  { icon: 'ri-focus-3-line', title: 'Client-First Focus', desc: 'Every decision we make starts with one question: how does this benefit our client?' },
  { icon: 'ri-shield-check-line', title: 'Integrity Always', desc: 'We deliver honest assessments and transparent communication, even when it\'s not what you want to hear.' },
  { icon: 'ri-leaf-line', title: 'Continuous Growth', desc: 'Technology never stops evolving, and neither do we. Our team invests 200+ hours annually in certifications and training.' },
  { icon: 'ri-team-line', title: 'Collaborative Mindset', desc: 'We work as an extension of your team, not a distant vendor — your success is our success.' },
];

const certifications = [
  { icon: 'ri-microsoft-line', name: 'Microsoft Gold Partner', desc: 'Azure & Microsoft 365 expertise' },
  { icon: 'ri-amazon-line', name: 'AWS Advanced Partner', desc: 'Cloud infrastructure specialist' },
  { icon: 'ri-google-line', name: 'Google Cloud Partner', desc: 'GCP certified architects' },
  { icon: 'ri-shield-check-line', name: 'Cisco Partner', desc: 'Networking & security solutions' },
  { icon: 'ri-lock-2-line', name: 'CISSP Certified', desc: 'Certified security professionals' },
  { icon: 'ri-award-line', name: 'ISO 27001 Aligned', desc: 'Information security management' },
];

export default function About() {
  return (
    <div className="min-h-screen bg-page">
      <Navbar />

      {/* Hero */}
      <section className="pt-28 pb-10 bg-white">
        <div className="mx-auto px-6 lg:px-10 xl:px-16 text-center">
          <span className="eyebrow">Our Story</span>
          <h1 className="text-3xl lg:text-4xl font-extrabold text-page-ink mb-3 tracking-[-0.03em]">About SunStone Systems</h1>
          <p className="text-page-muted text-base max-w-2xl mx-auto leading-relaxed font-light">
            Empowering Nigerian businesses through innovation, expertise, and unwavering dedication to technology excellence.
          </p>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-10 mx-auto px-6 lg:px-10 xl:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          <div>
            <span className="eyebrow">Our Mission</span>
            <h2 className="text-3xl font-extrabold text-page-ink mb-4 leading-tight tracking-[-0.02em]">
              We Exist to Make Technology Work for You
            </h2>
            <p className="text-page-muted text-base leading-relaxed mb-4 font-light">
              Founded in 2021, SunStone Systems Ltd. was built on a simple belief: Nigerian businesses deserve IT partners who take genuine ownership of their technology outcomes — not vendors who disappear after the contract is signed.
            </p>
            <p className="text-page-muted leading-relaxed text-sm">
              Today, we serve clients across Lagos, Abuja, and Port Harcourt in sectors including fintech, oil & gas, manufacturing, retail, and healthcare. Our team of certified professionals brings deep expertise, honest advice, and a relentlessly proactive approach to every engagement.
            </p>
          </div>
          <div className="relative">
            <div className={`${photoFrame} h-[400px]`}>
              <img
                src={photos.consulting}
                alt="Our Team"
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-10 bg-white">
        <div className="mx-auto px-6 lg:px-10 xl:px-16">
          <div className="text-center max-w-2xl mx-auto mb-8">
            <span className="eyebrow">What We Stand For</span>
            <h2 className="text-3xl font-extrabold text-page-ink mb-3 tracking-[-0.02em]">Our Core Values</h2>
            <p className="text-page-muted text-base font-light">The principles that guide every decision, every conversation, and every solution we deliver.</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            {values.map((v) => (
              <div key={v.title} className="bg-white rounded-xl p-7 border border-black/[0.08] hover:border-[#c97a2b]/30 transition-colors shadow-[0_1px_2px_rgba(0,0,0,0.04)]">
                <div className="w-12 h-12 flex items-center justify-center bg-[#c97a2b]/10 border border-[#c97a2b]/20 rounded-xl mb-5">
                  <i className={`${v.icon} text-[#c97a2b] text-xl`} />
                </div>
                <h3 className="font-bold text-page-ink text-lg mb-3">{v.title}</h3>
                <p className="text-page-muted text-sm leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="py-10 mx-auto px-6 lg:px-10 xl:px-16">
        <div className="text-center max-w-2xl mx-auto mb-8">
          <span className="eyebrow">Leadership</span>
          <h2 className="text-3xl font-extrabold text-page-ink mb-3 tracking-[-0.02em]">Meet Our Leaders</h2>
          <p className="text-page-muted text-base font-light">Experienced technology executives committed to your success.</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {team.map((member, index) => (
            <div key={index} className="group text-center">
              <div className="relative mb-5 inline-block">
                <div className="w-40 h-48 mx-auto rounded-xl overflow-hidden border border-black/[0.08] group-hover:border-[#c97a2b]/40 transition-colors bg-white flex items-center justify-center">
                  <span className="text-page-faint text-sm font-medium tracking-wide">Coming soon</span>
                </div>
              </div>
              {member.name && <h3 className="font-bold text-page-ink text-lg">{member.name}</h3>}
              {member.role && <p className="text-[#c97a2b] text-sm font-semibold mb-2">{member.role}</p>}
              {member.bio && <p className="text-page-faint text-sm leading-relaxed">{member.bio}</p>}
            </div>
          ))}
        </div>
      </section>

      {/* Certifications */}
      <section className="py-10 bg-white">
        <div className="mx-auto px-6 lg:px-10 xl:px-16">
          <div className="text-center max-w-2xl mx-auto mb-8">
            <span className="eyebrow">Credentials</span>
            <h2 className="text-3xl font-extrabold text-page-ink mb-3 tracking-[-0.02em]">Certifications & Partnerships</h2>
            <p className="text-page-muted text-base font-light">Our credentials back up our expertise.</p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
            {certifications.map((cert) => (
              <div key={cert.name} className="bg-white rounded-xl p-5 text-center border border-black/[0.08] hover:border-[#c97a2b]/35 transition-colors shadow-[0_1px_2px_rgba(0,0,0,0.04)]">
                <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3">
                  <i className={`${cert.icon} text-[#c97a2b] text-2xl`} />
                </div>
                <div className="text-page-ink text-xs font-bold mb-1">{cert.name}</div>
                <div className="text-page-faint text-xs">{cert.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-white">
        <div className="mx-auto px-6 lg:px-10 xl:px-16 text-center max-w-2xl">
          <h2 className="text-3xl font-extrabold text-page-ink mb-4 tracking-[-0.02em]">Ready to Work Together?</h2>
          <p className="text-page-muted text-base mb-6 font-light">Let's start a conversation about how SunStone Systems can transform your IT environment.</p>
          <Link to="/contact" className="btn-primary">
            Start the Conversation
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
